import { render, staticRenderFns } from "./ItsCustomsDeclearation.vue?vue&type=template&id=280b88e9&scoped=true&"
import script from "./ItsCustomsDeclearation.vue?vue&type=script&lang=js&"
export * from "./ItsCustomsDeclearation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280b88e9",
  null
  
)

export default component.exports